import CreateCampaignFormPresenter from "./CreateCampaignFormPresenter";

export default CreateCampaignFormPresenter;